import { render, staticRenderFns } from "./OrganizerContacts.vue?vue&type=template&id=b93c01a4&scoped=true&lang=pug"
import script from "./OrganizerContacts.vue?vue&type=script&lang=js"
export * from "./OrganizerContacts.vue?vue&type=script&lang=js"
import style0 from "./OrganizerContacts.vue?vue&type=style&index=0&id=b93c01a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93c01a4",
  null
  
)

export default component.exports